import { useEffect, useRef, useState } from "react";
import { EventsType } from "../Common/Types/types";
import { filterBy, orderBy } from "@progress/kendo-data-query";
import {
  Grid,
  GridCellProps,
  GridColumn,
  GridFilterCellProps,
} from "@progress/kendo-react-grid";
import moment from "moment";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import {
  Menu,
  MenuItem,
  MenuItemLink,
  MenuSelectEvent,
} from "@progress/kendo-react-layout";

interface EventsGridProps {
  data: any[] | null;
}
const EventsGrid = (props: EventsGridProps) => {
  const initialSort: any = [
    {
      field: "eventID",
      dir: "desc",
    },
  ];
  const initialDataState: { skip: number; take: number } = {
    skip: 0,
    take: 100,
  };
  const [data, setData] = useState<EventsType[]>([]);
  const [sort, setSort] = useState(initialSort);
  const [filter, setFilter] = useState();
  const [page, setPage] = useState<{ skip: number; take: number }>(
    initialDataState
  );

  useEffect(() => {
    if (props.data != null) {
      setData(props.data);
      if (props.data.length < initialDataState.take)
        setPage({ skip: 0, take: props.data.length });
    }
  }, [props.data]);

  const filterChange = (event: any) => {
    if (props.data != null) {
      setData(filterBy(props.data, event.filter));
      setFilter(event.filter);
    }
  };
  const pageChange = (event: any) => {
    setPage(event.page);
  };
  const _export = useRef<ExcelExport | null>(null);
  const excelExport = (event: MenuSelectEvent) => {
    if (event.item.text === "Export to Excel") {
      if (_export.current !== null) {
        _export.current.save();
      }
    }
  };
  function renderMenuIconIfApplicable(props: any) {
    return props.item.icon ? (
      <span
        style={{ fontSize: "16px" }}
        className={`k-icon k-i-${props.item.icon}`}
        role="presentation"
        key="0"
      />
    ) : null;
  }
  const linkRender = (props: any) => {
    return (
      <MenuItemLink url={props.item.url} opened={props.opened}>
        {[renderMenuIconIfApplicable(props), props.item.text, null]}
      </MenuItemLink>
    );
  };
  if (data == null) {
    return null; //<div>No data found for selected filters</div>;
  }
  const customCreatedDateCell = (props: GridCellProps) => {
    if (props.dataItem.created !== "") {
      return <td>{moment(props.dataItem.created).format("DD.MM.YYYY")}</td>;
    }
    return <td>{props.dataItem.created}</td>;
  };

  return (
    <div style={{ height: "100%", position: "relative" }}>
      <div
        style={{
          position: "absolute",
          top: "-20px",
          left: "-20px",
        }}
      >
        <Menu openOnClick={true} onSelect={excelExport} linkRender={linkRender}>
          <MenuItem
            text=""
            icon="more-horizontal"
            data={{}}
            cssStyle={{ color: "black" }}
          >
            <MenuItem text="Export to Excel" />
          </MenuItem>
        </Menu>
      </div>
      <ExcelExport data={data} ref={_export}>
        <Grid
          data={orderBy(data, sort).slice(page.skip, page.take + page.skip)}
          style={{ height: "100%" }}
          sortable={true}
          skip={page.skip}
          take={page.take}
          pageSize={page.take}
          total={data.length}
          sort={sort}
          onSortChange={(e) => {
            setSort(e.sort);
          }}
          filterable={false}
          filter={filter}
          //scrollable={"virtual"}
          onFilterChange={filterChange}
          pageable={false}
          onPageChange={pageChange}
          resizable={true}
        >
          <GridColumn
            field="created"
            title="Date"
            width="100px"
            cell={customCreatedDateCell}
          />
          <GridColumn field="authorName" title="User" width="150px" />
          <GridColumn field="comment" title="Description" width="150px" />
          <GridColumn
            field="timeSpentSeconds"
            title="Work Hours"
            width="110px"
          />
        </Grid>
      </ExcelExport>
    </div>
  );
};
export default EventsGrid;
